import React from 'react';

const NanoBanana = () => (
  <article className="news-article-body">
    <p className="news-lead">
      "Nano Banana" sounds like a children's snack, but inside Google it was the codename
      for one of the company's most strategically important projects: ultra-small AI models
      that run entirely on your phone. The product is now officially called Gemini Nano -
      and it's in over a billion Android devices.
    </p>

    <h2>What Gemini Nano actually does</h2>
    <p>
      Gemini Nano is designed for one thing: useful AI features that work on-device, without
      sending data to the cloud. On a Pixel 9 or a compatible Android device, that enables:
    </p>
    <ul>
      <li><strong>Smart Reply:</strong> Context-aware reply suggestions in messaging apps</li>
      <li><strong>Recording app summarisation:</strong> Transcribe and summarise voice memos locally</li>
      <li><strong>Gboard AI:</strong> Better autocorrect and text completion</li>
      <li><strong>Offline translation:</strong> Better accuracy than previous on-device models</li>
      <li><strong>Circle to Search:</strong> AI-powered image search using the Nano model for initial processing</li>
    </ul>

    <h2>Why on-device matters</h2>
    <p>
      The obvious reason is privacy - your voice notes and messages never leave your phone.
      But there are practical reasons too:
    </p>
    <ul>
      <li><strong>No latency:</strong> On-device inference is instant. No round-trip to a server.</li>
      <li><strong>No connectivity requirement:</strong> Works on a plane, in the subway, with no signal.</li>
      <li><strong>No cost at scale:</strong> Running inference on a billion devices would cost Google billions in cloud compute. On-device shifts that cost to the hardware Google sold you years ago.</li>
    </ul>

    <h2>The technical challenge</h2>
    <p>
      Fitting a capable AI model onto a smartphone chip is genuinely hard. The Pixel 9's
      Tensor G4 chip has dedicated AI cores, but they're a fraction of the compute in an
      H100 GPU. Making Gemini Nano useful required aggressive quantisation (running model
      weights in 4-bit or 8-bit rather than 16-bit), careful pruning, and knowledge
      distillation from the larger Gemini models.
    </p>
    <p>
      The result is a model that's "only" a few billion parameters - small enough to fit
      in phone RAM, fast enough to respond in milliseconds, but capable enough to be
      genuinely useful for common tasks.
    </p>

    <h2>The AI Kit extension</h2>
    <p>
      Google also released Android AI Kit, which lets third-party app developers access
      Gemini Nano via a standard API. This means any app can use on-device AI for
      summarisation, classification, or text generation without needing cloud connectivity
      or a proprietary model. That's a significant shift in how mobile developers can
      build AI features.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        On-device AI isn't a fallback for when you don't have connectivity - it's becoming
        the primary experience for everyday tasks. Gemini Nano proves that useful AI doesn't
        require a cloud supercomputer. As phone chips get faster and models get more efficient,
        the gap between cloud and on-device AI will keep shrinking - and privacy-preserving,
        always-available AI will become the norm.
      </p>
    </div>
  </article>
);

export default NanoBanana;
